import { FormattedMessage, useIntl } from 'react-intl';

import { useIsTopBarHidden } from '@xing-com/crate-hooks-use-is-top-bar-hidden';
import { TopBar } from '@xing-com/crate-layout-top-bar';
import { IconArrowLeft } from '@xing-com/icons';

import { FOLLOWING_OVERVIEW_TAB, Paths } from '../../paths';

import * as Styled from './back-button.styles';

export const BackButton: React.FC = () => {
  const FOLLOWING_PATH_PATTERN = /\/news\/selections\/following$/;
  const referrer = typeof window !== 'undefined' ? document.referrer : '';
  const [baseReferrer, parametersReferrer] = referrer.split('?');
  const isFollowingPath = FOLLOWING_PATH_PATTERN.test(baseReferrer);
  const isTopBarHidden = useIsTopBarHidden();
  const { formatMessage } = useIntl();

  const referrerParams = new URLSearchParams(parametersReferrer);
  const tabParam = referrerParams.get('tab');

  const messageId = isFollowingPath
    ? 'FOLLOWING_RECOMMENDATION_PAGE_BACK_FOLLOWING'
    : 'FOLLOWING_RECOMMENDATION_PAGE_BACK_RECOMMENDATIONS';
  const returnURL = isFollowingPath
    ? tabParam
      ? FOLLOWING_OVERVIEW_TAB(tabParam)
      : Paths.IS_FOLLOWING_OVERVIEW
    : Paths.RECOMMENDATIONS_OVERVIEW;
  const ariaLabelId = isFollowingPath
    ? 'NEWS_SOURCES_ARIA_LABEL_I_FOLLOW'
    : 'NEWS_SOURCES_ARIA_LABEL_RECOMMENDATIONS';

  return isTopBarHidden ? (
    <Styled.TextButton
      icon={IconArrowLeft}
      href={returnURL}
      aria-label={formatMessage({ id: ariaLabelId })}
    >
      <FormattedMessage id={messageId} />
    </Styled.TextButton>
  ) : (
    <TopBar
      title={formatMessage({
        id: messageId,
      })}
      type="subheader"
      skipAdditionalButtons
      backButtonUrl={returnURL}
    />
  );
};
